import React, { useEffect, useState } from 'react'
import { Chart } from "react-google-charts";
function LineChart({chartdata}) {
    const [data,setData]=useState([["Date","Prices"]]);
    useEffect(()=>{
        let dataCopy=[["Date","Prices"]];
        if(chartdata.prices){
            chartdata.prices.map((item)=>{
                return dataCopy.push([`${new Date(item[0]).toLocaleDateString().slice(0,-5)}`,item[1]])
            })
            setData(dataCopy);
        }
    },[chartdata.prices])
  return (
    <Chart 
        chartType='LineChart'
        data={(data)}
        height="100%"
        legendToggle 
    />
  )
}

export default LineChart